<template>
    <div class="overviewContainer">
        <common-title-panel title="실내 환경 운영 개요" />

        <!-- DI 카드 -->
        <div class="overviewCard" :style="{ backgroundColor: getDiColor(currentDI) }">
            <div class="overviewCardFirstRow">
                <div class="overviewCardfirstRowTitle">
                    <div class="firstRowTitle">
                        불쾌지수
                        <div class="iconBox" v-b-tooltip.hover :title="DItext">
                            <i class="fas fa-exclamation icon"></i>
                        </div>
                    </div>
                    <div class="firstRowSubTitle">Discomfort Index</div>
                </div>
                <div class="overviewCardFirstRowContent">
                    <div class="overviewFirstRowValue">{{ currentDI }}</div>
                    <div class="overviewExpression">
                        <SmileyFace :mood="calcGradeDi(currentDI)" v-if="currentDI !== '-'" />
                    </div>
                </div>
            </div>
            <div class="overviewCardSecondRow">
                <div class="prevMonth">
                    <div class="timeLabel">이전</div>
                    <div class="cardValue">{{ prevLeftDI }}</div>
                </div>
                <div class="sameMonthLastYear">
                    <div class="timeLabel">비교</div>
                    <div class="cardValue">{{ prevRightDI }}</div>
                </div>
            </div>
        </div>

        <div class="blank"></div>

        <!-- IAQ 카드 -->
        <div class="overviewCard" :style="{ backgroundColor: getIAQColor(currentCO2) }">
            <div class="overviewCardFirstRow">
                <div class="overviewCardfirstRowTitle">
                    <div class="firstRowTitle">
                        실내 공기질
                        <div class="iconBox" v-b-tooltip.hover :title="CO2text">
                            <i class="fas fa-exclamation icon"></i>
                        </div>
                    </div>
                    <div class="firstRowSubTitle">Indoor Air Quality</div>
                </div>
                <div class="overviewCardFirstRowContent">
                    <div class="overviewFirstRowValue">{{ currentCO2 }}</div>
                    <div class="overviewExpression">
                        <SmileyFace :mood="calcGradeIAQ(currentCO2)" v-if="currentCO2 !== '-'" />
                    </div>
                </div>
            </div>
            <div class="overviewCardSecondRow">
                <div class="prevMonth">
                    <div class="timeLabel">이전</div>
                    <div class="cardValue">{{ prevLeftCO2 }}</div>
                </div>
                <div class="sameMonthLastYear">
                    <div class="timeLabel">비교</div>
                    <div class="cardValue">{{ prevRightCO2 }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CommonTitlePanel from "./CommonTitlePanel.vue";
import SmileyFace from "./HumanExpressionPanel.vue";

export default {
    components: {
        SmileyFace,
        CommonTitlePanel,
    },
    props: {
        data: Object,
        timeDsvn: String,
    },
    computed: {
        currentDI() {
            return this.getAvgValue("DI", "current");
        },
        prevLeftDI() {
            return this.getAvgValue("DI", "prevLeft");
        },
        prevRightDI() {
            return this.getAvgValue("DI", "prevRight");
        },
        currentCO2() {
            return this.getAvgValue("CO2", "current");
        },
        prevLeftCO2() {
            return this.getAvgValue("CO2", "prevLeft");
        },
        prevRightCO2() {
            return this.getAvgValue("CO2", "prevRight");
        },
    },
    data() {
        return {
            smile: "#448AFF",
            sad: "#FFA000",
            angry: "#FF5252",
            DItext: "DI 지수는 29 이하일 시 쾌적, 30과 39 사이일 시 불편, 40 이상일 때 주의를 나타내는 지수입니다.",
            CO2text:
                "실내 환경지수는 실내 CO2 지수 기반으로서 700 이하일 시 쾌적, 700 ~ 1000일시 불편, 1000 이상일 시 주의를 나타냅니다.",
        };
    },
    methods: {
        getAvgValue(type, position) {
            if (!this.data?.chartData?.[type]) return "-";

            const map = {
                MONTH: {
                    current: "currentMonth",
                    prevLeft: "prevMonth",
                    prevRight: "prevYearMonth",
                },
                YEAR: {
                    current: "currentYear",
                    prevLeft: "prevYear",
                    prevRight: "prevPrevYear",
                },
            };

            const key = map[this.timeDsvn]?.[position];
            return this.data.chartData[type]?.[key]?.AVG ?? "-";
        },
        calcGradeDi(val) {
            if (val <= 29) return "smile";
            else if (val <= 39) return "sad";
            else return "angry";
        },
        calcGradeIAQ(val) {
            if (val <= 700) return "smile";
            else if (val <= 1000) return "sad";
            else return "angry";
        },
        getDiColor(val) {
            const mood = this.calcGradeDi(val);
            return this[mood] || this.smile;
        },
        getIAQColor(val) {
            const mood = this.calcGradeIAQ(val);
            return this[mood] || this.smile;
        },
    },
};
</script>

<style scoped>
.overviewContainer {
    width: 100%;
    height: 100%;
    padding: 5px;
}
.overviewTitle {
    width: 100%;
    height: 10%;
    font-size: 18px;
    font-weight: 800;
    color: #4d4d4d;
    display: flex;
    justify-content: center;
}
.blank {
    width: 100%;
    height: 3%;
}
.overviewCard {
    width: 100%;
    height: 40%;
    background-color: #007bff;
    border-radius: 8px;
    padding: 10px 15px 10px 15px;
}
.overviewCardFirstRow {
    width: 100%;
    height: 50%;
    display: flex;
    justify-content: space-between;
}
.overviewCardfirstRowTitle {
    width: 50%;
}
.overviewCardFirstRowContent {
    width: 50%;
    height: 50%;
    display: flex;
    justify-content: flex-end;
}
.overviewCardSecondRow {
    width: 100%;
    height: 50%;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.prevMonth {
    width: 45%;
    display: flex;
    height: 70%;
}
.timeLabel {
    width: 35%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    font-weight: 700;
}
.cardValue {
    width: 60%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: white;
    border-radius: 15px;
    font-weight: 700;
}
.sameMonthLastYear {
    width: 47%;
    height: 70%;
    display: flex;
    justify-content: space-between;
}
.firstRowTitle {
    font-size: 20px;
    font-weight: 800;
    color: yellow;
    display: flex;
}
.firstRowSubTitle {
    color: yellow;
}
.overviewFirstRowValue {
    font-size: 25px;
    font-weight: 800;
    color: yellow;
    margin-right: 17px;
}
.icon {
    border: 1px solid white;
    color: white;
    border-radius: 50%;
    font-size: 10px;
    display: inline-block;
    width: 18px;
    height: 18px;
    text-align: center;
    line-height: 16px;
    margin-left: 6px;
}
.iconBox {
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
